/*
  Y2K PDP davranışları (CLAUDE.md §7) — Dawn JS'i YENİDEN YAZILMAZ (§14),
  üstüne eklenir. Tema editörü section:load'da yeniden kurulur.

  Madde 2: ana galeri görsellerine data-tilt (y2k-tilt.js bu dosyadan SONRA
  yüklenip tarar — main-product.liquid'deki script sırası önemli).
  Madde 4: - Dawn'ın stok dışı işaretlediği bedenler (input.disabled sınıfı)
             gerçek disabled attribute'una çevrilir: tıklanamaz + odaklanamaz.
             Dawn variant değişiminde picker'ı yeniden render ettiği için
             MutationObserver ile tekrar uygulanır.
           - Seçimsiz başlangıç: birden çok beden varsa sayfa seçili beden
             OLMADAN açılır (URL'de ?variant= yoksa). Tek bedenli üründe
             Dawn'ın ön seçimi korunur.
           - Beden seçilmeden SEPETE EKLE: gönderim durdurulur, seçiciye
             yumuşak scroll + kısa vurgu (panel sarsılmaz).
*/
(function () {
  'use strict';

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Varyant isteği korumaya takılırsa (2026-11-02) ----------
     Beden/numara değişince Dawn ürün bölümünü ?option_values=…&section_id=… ile
     yeniden ister. Shopify'ın bot koruması bu isteğe 429 "Verifying your
     connection…" sayfası dönerse Dawn yanıtta varyant bulamaz ve butonu KALICI
     "KULLANIM DIŞI" yapar (ölçüldü: yoğun otomatik testte tekrar tekrar oldu;
     tema kodu ve beden metni kodu masum). Böyle bir yanıtta sayfa aynı seçimle
     TAM yüklenir (?option_values=… — Shopify o varyantı seçili açar); tarayıcı
     doğrulamayı geçer, ziyaretçi seçtiği bedende kalır. Başarılı yanıta dokunulmaz. */
  if (window.fetch && !window.__y2kVaryantKoruma) {
    window.__y2kVaryantKoruma = true;
    var fetchOrijinal = window.fetch;
    window.fetch = function (girdi) {
      var adres = typeof girdi === 'string' ? girdi : (girdi && girdi.url) || '';
      var istek = fetchOrijinal.apply(this, arguments);
      if (adres.indexOf('option_values=') === -1 || adres.indexOf('section_id=') === -1) return istek;
      return istek.then(function (yanit) {
        if (!yanit.ok) {
          var hedef = new URL(adres, window.location.href);
          hedef.searchParams.delete('section_id');
          window.location.assign(hedef.toString());
        }
        return yanit;
      });
    };
  }

  function pillInputs(root) {
    var scope = root && root.querySelectorAll ? root : document;
    return scope.querySelectorAll('.product-form__input--pill input[type="radio"]');
  }

  /* ---------- Madde 2: galeri tilt ---------- */
  function setupGalleryTilt(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('media-gallery .product__media').forEach(function (m) {
      m.setAttribute('data-tilt', '');
    });
  }

  /* ---------- Madde 4a: stok dışı beden gerçekten kapalı ---------- */
  function markDisabled(root) {
    pillInputs(root).forEach(function (input) {
      if (input.classList.contains('disabled')) input.disabled = true;
    });
  }

  function watchPickerRerenders(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('variant-selects').forEach(function (vs) {
      if (vs.dataset.y2kWatched) return;
      vs.dataset.y2kWatched = '1';
      new MutationObserver(function () {
        // Dawn picker'ı yeniden render etti: disabled + görsel kilit tazele
        markDisabled(vs);
        setupUnpicked();
      }).observe(vs, { childList: true, subtree: true });
    });
  }

  /* ---------- Madde 4b: seçimsiz başlangıç (GÖRSEL katman) ----------
     Radyoları gerçekten boşaltmak Dawn'ın state makinesiyle çatışıyor
     (Dawn hidrasyon/yeniden render'da seçimi geri getiriyor). Bunun yerine
     Dawn'ın ön seçimi DOKUNULMADAN korunur; fieldset'e y2k-unpicked sınıfı
     eklenir: seçili pill nötr görünür, kullanıcı bir bedene tıklayana kadar
     SEPETE EKLE engellenir. Dawn ile sıfır çatışma. */
  function setupUnpicked() {
    if (window.__y2kSizePicked) return;               // kullanıcı zaten seçti
    var inputs = pillInputs(document);
    if (inputs.length < 2) return;                    // tek beden: ön seçim kalsın
    // linkle gelinen beden korunur; ?option_values= = varyant koruması sonrası yeniden yükleme
    if (/[?&](variant|option_values)=/.test(location.search)) return;
    document.querySelectorAll('.product-form__input--pill').forEach(function (fs) {
      fs.classList.add('y2k-unpicked');
    });
  }

  function clearUnpicked() {
    window.__y2kSizePicked = true;
    document.querySelectorAll('.product-form__input--pill.y2k-unpicked').forEach(function (fs) {
      fs.classList.remove('y2k-unpicked');
    });
  }

  // Kullanıcı beden seçti: görsel kilit kalkar (capture: Dawn'dan bağımsız)
  document.addEventListener(
    'change',
    function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('.product-form__input--pill input[type="radio"]')) return;
      clearUnpicked();
    },
    true
  );

  // KRİTİK: Dawn ilk bedeni teknik olarak checked tutar (kilit yalnızca
  // görsel). ZATEN seçili pill'e tıklamak/Space basmak change ÜRETMEZ —
  // kullanıcı "40"a tıklıyor ama kilit kalkmıyor, SEPETE EKLE sonsuza dek
  // engelleniyordu. Tıklama da seçim sayılır (label VEYA radyonun kendisi).
  document.addEventListener(
    'click',
    function (e) {
      var t = e.target && e.target.closest
        ? e.target.closest('.product-form__input--pill label, .product-form__input--pill input[type="radio"]')
        : null;
      if (!t) return;
      var input = t.tagName === 'LABEL' ? t.control : t;
      if (!input || input.disabled) return;
      clearUnpicked();
    },
    true
  );

  // Chrome, ZATEN seçili radyoda Space için click olayı da üretmiyor —
  // klavye kullanıcısının "onayla" niyeti keyup'tan yakalanır
  document.addEventListener(
    'keyup',
    function (e) {
      if (e.key !== ' ' && e.key !== 'Enter') return;
      var t = e.target;
      if (!t || !t.matches || !t.matches('.product-form__input--pill input[type="radio"]')) return;
      if (t.disabled) return;
      clearUnpicked();
    },
    true
  );

  function sizeChosen() {
    return !document.querySelector('.product-form__input--pill.y2k-unpicked');
  }

  /* ---------- Madde 4c: EKLE'de yumuşak scroll + vurgu ---------- */
  // Dawn'ın submit handler'ından ÖNCE yakalamak için document capture.
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      // DİKKAT: form.id KULLANILAMAZ — Shopify ürün formundaki
      // <input name="id"> form.id'yi gölgeleyip elementi döndürür.
      var formId = form && form.getAttribute ? form.getAttribute('id') : null;
      if (!formId || formId.indexOf('product-form-') !== 0) return;
      if (formId.indexOf('product-form-installment') === 0) return;
      if (form.closest && form.closest('quick-add-modal')) return;
      if (sizeChosen()) return;

      e.preventDefault();
      e.stopPropagation();

      var fieldset = document.querySelector('.product-form__input--pill');
      if (!fieldset) return;
      fieldset.scrollIntoView({ behavior: REDUCE ? 'auto' : 'smooth', block: 'center' });
      fieldset.classList.remove('y2k-attention');
      void fieldset.offsetWidth; // animasyonu yeniden tetiklemek için reflow
      fieldset.classList.add('y2k-attention');

      // Görsel vurgu ekran okuyucuya ulaşmaz: odak ilk seçilebilir bedene
      // taşınır (klavyede de doğru yere iner) + canlı bölge duyurur
      var firstPick = fieldset.querySelector('input[type="radio"]:not(:disabled)');
      if (firstPick) firstPick.focus({ preventScroll: true });
      announce('Sepete eklemek için önce beden seçin.');
    },
    true
  );

  /* ---------- Ekran okuyucu duyuruları (görünmez canlı bölge) ---------- */
  function announce(msg) {
    var region = document.getElementById('Y2kA11yStatus');
    if (!region) {
      region = document.createElement('div');
      region.id = 'Y2kA11yStatus';
      region.className = 'visually-hidden';
      region.setAttribute('role', 'status');
      region.setAttribute('aria-live', 'polite');
      document.body.appendChild(region);
    }
    region.textContent = '';
    // aynı metin art arda da okunsun diye önce boşaltıp sonra yaz
    setTimeout(function () { region.textContent = msg; }, 60);
  }

  /* ---------- Madde 5: SEPETE EKLE durum tasarımları (§7) ----------
     normal / hover: CSS'te. Burası loading + başarı:
     - Dawn loading sınıfını ekleyip spinner gösterir; CSS spinner'ı gizler,
       metin "EKLENİYOR…" + yanıp sönen ✦ olur.
     - Başarı sinyali Dawn'ın cartUpdate pub/sub yayını (yalnızca başarıda
       yayınlanır); buton 1.2 sn "SEPETTE ✦" gösterip normale döner,
       header'daki sepet pill'i zıplar. Hata durumunda metin anında eski
       hâline döner (Dawn hata mesajını kendisi gösterir). */
  var cartAddSignal = 0;

  function bounceCartPill() {
    var cart = document.getElementById('cart-icon-bubble');
    if (!cart) return;
    cart.classList.remove('y2k-bounce');
    void cart.offsetWidth; // animasyonu yeniden tetiklemek için reflow
    cart.classList.add('y2k-bounce');
    cart.addEventListener(
      'animationend',
      function () { cart.classList.remove('y2k-bounce'); },
      { once: true }
    );
  }

  // DİKKAT: PUB_SUB_EVENTS 'const' ile tanımlı — window'a YAZILMAZ;
  // bare identifier + typeof ile kontrol edilmeli (window.PUB_SUB_EVENTS undefined)
  if (
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined' &&
    PUB_SUB_EVENTS.cartUpdate &&
    !window.__y2kCartSub
  ) {
    window.__y2kCartSub = true;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
      if (!ev || ev.source !== 'product-form') return;
      cartAddSignal++;
      bounceCartPill();
    });
  }

  function setupButtonStates() {
    var btn = document.querySelector('.product-form__submit');
    if (!btn || btn.dataset.y2kStates) return;
    btn.dataset.y2kStates = '1';
    var label = btn.querySelector('span');
    if (!label) return;

    var original = label.textContent;
    var signalAtStart = 0;
    var revertTimer = 0;

    new MutationObserver(function () {
      var loading = btn.classList.contains('loading');
      if (loading) {
        if (label.textContent !== 'EKLENİYOR…') original = label.textContent;
        signalAtStart = cartAddSignal;
        clearTimeout(revertTimer);
        label.textContent = 'EKLENİYOR…';
      } else if (label.textContent === 'EKLENİYOR…') {
        if (cartAddSignal > signalAtStart) {
          label.textContent = 'SEPETTE ✦';
          btn.classList.add('y2k-success');
          revertTimer = setTimeout(function () {
            btn.classList.remove('y2k-success');
            label.textContent = original;
          }, 1200);
        } else {
          label.textContent = original; // hata: anında normale dön
        }
      }
    }).observe(btn, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- Madde 6: mobil sticky bar görünürlüğü (§7) ----------
     Kurallar: ana SEPETE EKLE ekrandayken GİZLİ; buton scroll'la çıkınca
     belirir (IO); footer görünürken gizli (içeriği örtmez); klavye açıkken
     gizli (visualViewport). Bar butonu form= ile ana formu gönderdiğinden
     beden kilidi ve durum akışı otomatik geçerli; ana buton metni/disabled
     durumu bara aynen yansıtılır. */
  function setupStickyBar() {
    var bar = document.querySelector('[data-y2k-sticky]');
    if (!bar || bar.dataset.y2kInit) return;
    bar.dataset.y2kInit = '1';

    var mainBtn = document.querySelector('.product-form__submit');
    if (!mainBtn) return;
    // Footer'ın TAMAMI değil, son şeridi (copyright) esas alınır: kısa
    // PDP'de footer üst kenarı kuralı barın görünürlük bandını ~50px'e
    // düşürüyordu — bar yalnızca sayfanın gerçek sonunda çekilsin
    var footer = document.querySelector('.footer__content-bottom') || document.querySelector('.footer');

    var btnOut = false;
    var footerIn = false;
    var keyboard = false;

    function apply() {
      bar.classList.toggle('y2k-sticky-bar--visible', btnOut && !footerIn && !keyboard);
    }

    new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) btnOut = !entries[i].isIntersecting;
      apply();
    }, { threshold: 0 }).observe(mainBtn);

    if (footer) {
      // Footer'ın ilk pikseli değil, bar'ın gerçekten İÇERİĞİ örteceği an
      // esas alınır: kök alanın altından bar yüksekliği kadar kırpılır —
      // footer bu çizgiyi geçince bar gizlenir (sayfa sonunda örtme yok)
      var barH = Math.max(bar.offsetHeight, 72);
      new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) footerIn = entries[i].isIntersecting;
        apply();
      }, { threshold: 0, rootMargin: '0px 0px -' + barH + 'px 0px' }).observe(footer);
    }

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', function () {
        // klavye açılınca görünür alan belirgin küçülür
        keyboard = window.visualViewport.height < window.innerHeight * 0.75;
        apply();
      });
    }

    // Ana buton metni + disabled + loading/success durumlarını bara yansıt
    var stickyBtn = bar.querySelector('[data-y2k-sticky-btn]');
    var stickyLabel = stickyBtn ? stickyBtn.querySelector('span') : null;
    var mainLabel = mainBtn.querySelector('span');
    if (stickyBtn && stickyLabel && mainLabel) {
      new MutationObserver(function () {
        stickyLabel.textContent = mainLabel.textContent;
        stickyBtn.disabled = mainBtn.disabled;
        stickyBtn.classList.toggle('loading', mainBtn.classList.contains('loading'));
        stickyBtn.classList.toggle('y2k-success', mainBtn.classList.contains('y2k-success'));
      }).observe(mainBtn, { attributes: true, childList: true, subtree: true, characterData: true });
    }

    // Variant değişiminde ana fiyat bloğu yeniden render olur — bara yansıt
    var priceHost = document.querySelector('.product__info-container .price');
    var stickyPrice = bar.querySelector('[data-y2k-sticky-price]');
    if (priceHost && stickyPrice) {
      new MutationObserver(function () {
        var item = priceHost.querySelector('.price-item--sale, .price-item--regular, .price-item');
        if (item) stickyPrice.textContent = item.textContent.trim();
      }).observe(priceHost, { childList: true, subtree: true, characterData: true });
    }
  }

  /* ---------- SADE: SEPETE EKLE metni seçili bedeni gösterir ----------
     Yalnız GÖRÜNÜM: buton metni + bir sınıf. Ekleme akışı (beden kilidi,
     Dawn submit, EKLENİYOR…/SEPETTE ✦ durumları) aynen çalışır.
     - Beden seçilmediyse "BEDEN SEÇ" / ayakkabıda "NUMARA SEÇ" (fieldset'in
       data-y2k-sec-metin'i; .y2k-beden-bekliyor), seçilince
       "SEPETE EKLE · 42". Dawn metni değiştirince (varyant değişimi) yeniden
       uygulanır.
     - Dokunulmaz: tek bedenli ürün, disabled buton (tükendi/kullanılamıyor),
       EKLENİYOR…/SEPETTE ✦ geçişi.
     - "Numaran yok mu?" linki wa.me ise hazır mesajdaki beden güncellenir. */
  function setupSizeLabel() {
    var btn = document.querySelector('.product-form__submit');
    if (!btn || btn.dataset.y2kSizeLabel) return;
    if (pillInputs(document).length < 2) return;
    btn.dataset.y2kSizeLabel = '1';
    var addText = ((window.variantStrings && window.variantStrings.addToCart) || 'Sepete ekle').toLocaleUpperCase('tr-TR');
    var gecis = /EKLENİYOR|SEPETTE/;

    function numaraLink(size) {
      var a = document.querySelector('[data-y2k-numara-wa]');
      if (!a) return;
      var base = a.getAttribute('data-y2k-numara-wa');
      var msg = 'Merhaba, ' + a.getAttribute('data-y2k-numara-urun') + ' için ' + (size || 'farklı bir') + ' ' + (a.getAttribute('data-y2k-numara-kelime') || 'numara') + ' arıyorum.';
      a.href = base + (base.indexOf('?') === -1 ? '?' : '&') + 'text=' + encodeURIComponent(msg);
    }

    function sync() {
      var label = btn.querySelector('span');
      if (!label) return;
      var t = label.textContent.trim();
      if (btn.disabled || gecis.test(t)) {
        // DİKKAT: classList.remove sınıf yokken bile class niteliğini yeniden
        // yazar (mutation kaydı) → setupButtonStates gözlemcisi EKLENİYOR…'yu
        // yeniden yazar → bu gözlemci yine tetiklenir: SONSUZ DÖNGÜ (32.10'da
        // sepete eklerken sayfa donuyordu). Yalnız gerçekten varsa kaldır.
        if (btn.classList.contains('y2k-beden-bekliyor')) btn.classList.remove('y2k-beden-bekliyor');
        return;
      }
      var checked = document.querySelector('.product-form__input--pill input[type="radio"]:checked');
      var bekliyor = !sizeChosen() || !checked;
      var bosMetin = (document.querySelector('[data-y2k-sec-metin]') || {}).dataset;
      var hedef = bekliyor ? ((bosMetin && bosMetin.y2kSecMetin) || 'BEDEN SEÇ') : addText + ' · ' + checked.value;
      if (btn.classList.contains('y2k-beden-bekliyor') !== bekliyor) btn.classList.toggle('y2k-beden-bekliyor', bekliyor);
      if (t !== hedef) label.textContent = hedef;
      numaraLink(bekliyor ? null : checked.value);
    }

    new MutationObserver(sync).observe(btn, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      subtree: true,
      characterData: true
    });
    // Beden seçimi (change) ve zaten seçili bedene tıklama/klavye. Kilidi
    // kaldıran capture dinleyicileri bundan ÖNCE çalışır → doğrudan çağrı.
    ['change', 'click', 'keyup'].forEach(function (ev) {
      document.addEventListener(ev, sync);
    });
    sync();
  }

  /* ---------- BEDEN TABLOSU (2026-11-03) ----------
     snippets/y2k-beden-tablosu.liquid (açılır bölüm, KARGO & İADE'nin üstünde). Üç iş:
     ① "Beden tablosu" linki (BEDEN başlığının sağında) bölümü açar ve sabit header'ın altına kaydırır;
     ② sekmeler "HANGİ BEDENİ ALMALIYIM?" / "ÖLÇÜ TABLOSU" (tık + ←/→/Home/End);
     ③ seçili bedenin satırı pembe (seçim yokken — y2k-unpicked — vurgu yok).
     Dinleyiciler belge düzeyinde ve BİR KEZ kurulur: Dawn picker'ı yeniden çizse de çalışır.
     Beden seçici, 429 koruması ve stokta olmayan bedenleri gizleme davranışına dokunmaz. */
  function btSeciliBeden() {
    var fs = document.querySelector('#MainContent .product-form__input--pill.y2k-beden-alani');
    if (!fs || fs.classList.contains('y2k-unpicked')) return null;
    var c = fs.querySelector('input[type="radio"]:checked');
    return c ? c.value : null;
  }

  function btVurgula(deger) {
    document.querySelectorAll('#y2k-beden-tablosu tr[data-y2k-bt-beden]').forEach(function (tr) {
      var on = deger !== null && tr.getAttribute('data-y2k-bt-beden') === deger;
      tr.classList.toggle('y2k-bt__satir--secili', on);
    });
  }

  function btSekme(btn, odak) {
    var liste = btn.parentNode;
    Array.prototype.forEach.call(liste.querySelectorAll('[data-y2k-bt-sekme]'), function (s) {
      var secili = s === btn;
      s.setAttribute('aria-selected', secili ? 'true' : 'false');
      s.tabIndex = secili ? 0 : -1;
      var panel = document.getElementById(s.getAttribute('aria-controls'));
      if (panel) panel.hidden = !secili;
    });
    if (odak) btn.focus();
  }

  function setupBedenTablosu() {
    if (window.__y2kBt) {
      btVurgula(btSeciliBeden());
      return;
    }
    window.__y2kBt = true;

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var link = e.target.closest('[data-y2k-bt-ac]');
      if (link) {
        var kutu = document.getElementById('y2k-beden-tablosu');
        if (!kutu) return;
        e.preventDefault();
        var d = kutu.querySelector('details');
        if (d) d.open = true;
        var header = document.querySelector('.section-header');
        var pay = (header ? header.getBoundingClientRect().bottom : 0) + 12;
        var hedef = kutu.getBoundingClientRect().top + window.pageYOffset - Math.max(pay, 12);
        window.scrollTo({ top: hedef, behavior: REDUCE ? 'auto' : 'smooth' });
        var ozet = d && d.querySelector('summary');
        if (ozet) ozet.focus({ preventScroll: true });
        return;
      }
      var sekme = e.target.closest('[data-y2k-bt-sekme]');
      if (sekme) btSekme(sekme, false);
      // Zaten seçili (Dawn'ın ön seçimi) bedene tıklama "change" üretmez — seçim kilidi kalkınca vurgula
      if (e.target.closest('.y2k-beden-alani')) {
        setTimeout(function () {
          btVurgula(btSeciliBeden());
        }, 0);
      }
    });

    document.addEventListener('keydown', function (e) {
      var sekme = e.target.closest && e.target.closest('[data-y2k-bt-sekme]');
      if (!sekme || ['ArrowRight', 'ArrowLeft', 'Home', 'End'].indexOf(e.key) === -1) return;
      e.preventDefault();
      var hepsi = Array.prototype.slice.call(sekme.parentNode.querySelectorAll('[data-y2k-bt-sekme]'));
      var i = hepsi.indexOf(sekme);
      var n = hepsi.length;
      var j = e.key === 'Home' ? 0 : e.key === 'End' ? n - 1 : e.key === 'ArrowRight' ? (i + 1) % n : (i - 1 + n) % n;
      btSekme(hepsi[j], true);
    });

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('.y2k-beden-alani input[type="radio"]')) btVurgula(t.value);
    });

    btVurgula(btSeciliBeden());
  }

  function setup(root) {
    setupGalleryTilt(root);
    markDisabled(root);
    watchPickerRerenders(root);
    setupUnpicked();
    setupButtonStates();
    setupStickyBar();
    setupSizeLabel();
    setupBedenTablosu();
  }

  setup(document);
  document.addEventListener('shopify:section:load', function (e) {
    setup(e.target);
  });
})();
